var path = 'admin/admin.tpl.html';
var html = "<react-component name='admin' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;